export type Screen = {
  aspectNormalized: number;
};

export const screen = {
  aspectNormalized: 0,
};
